import axios from 'axios'

const api = axios.create({
  headers: { 'Content-Type': 'Application/json; charset=UTF-8' },
  timeout: 30000
})

api.defaults.baseURL = process.env.VUE_APP_API_URL

export default api
